// libs
import { styled } from '@nykaa/ui-components';

//icons
import Leaves from '@nykaa/ui-components/Icons/leaves';

export const HeaderContainer = styled.div<{ background: string }>`
  display: flex;
  text-decoration: none;
  flex-direction: row;
  background: ${({ background }) => background};
  padding: ${({ theme }) => theme.spacing.spacing20};
  border-radius: ${({ theme }) => `${theme.borders.radius10} ${theme.borders.radius10} 0 0`};
`;

export const HeaderText = styled.span<{ color: string }>`
  display: block;
  color: ${({ color }) => color};
  ${({ theme }) => theme.typography.labelSmall}
`;

export const HeaderIcon = styled(Leaves)`
  height: 12px;
  width: 10px;
  margin-right: ${({ theme }) => theme.spacing.spacing10};
  vertical-align: top;
`;

export const HeaderDetails = styled.div`
  margin: 0 auto;
  display: inline-flex;
`;
